import { InfoWrapper } from './QuestInfo.styles';
import Title from 'components/Typography/Title';
import Label from 'components/Typography/Label';
import { InfoProps } from './QuestInfo.types';

const QuestInfo = ({ label, title }: InfoProps) => {
  return (
    <InfoWrapper>
      <Label>{label}</Label>
      <Title level={3} renderAs="h3">
        {title}
      </Title>
    </InfoWrapper>
  );
};

export default QuestInfo;
